import React from 'react';
import { FormikProps } from 'formik';
import { LabelFieldHorizontal, TextInput } from '@epicode/react-inspinia';
import { QuestionnaireElement } from '../../../../api/jobOffers/jobOffers.dto';

export function renderQuestionnaireSingleLineText<T extends Record<string, any>>(formikProps: FormikProps<T>) {
    return (element: QuestionnaireElement, label?: string) => (
        <LabelFieldHorizontal for={element.id} label={label} key={element.id}>
            <TextInput
                name={element.id}
                value={formikProps.values[element.id] || ''}
                onChange={formikProps.handleChange}
                onBlur={formikProps.handleBlur}
            />
        </LabelFieldHorizontal>
    );
}
